/**
 * Role type IDs used across the application.
 * Change IDs here to update everywhere.
 */
export enum RoleTypeId {
  Employee = 1,
  Admin = 2,
}
